import React, { useEffect, useState } from "react";
 
import { Link } from "react-router-dom";
import Api from "../../Hooks/Api";
const MouReport = (props) => {
  const [state, setState] = useState([]);
  const [responsemessage, setresponsemessage] = useState("");
  const fetchData = () => {
      setresponsemessage("")
      setState([]);
   
      let url = "api/reports/mou";
      Api.get(url)
          .then(function (response) {
              if (response.data.length == 0) {
                  setresponsemessage("No data found")
              }
              setState(response.data)
          })
          .catch(function (error) {
          })
          .then(function () {
              // always executed
          })

  };
  useEffect(() => {
      fetchData();     ;  
  }, []); 
  
  const handlePrint = () => {
      
      // let uri = process.env.REACT_APP_BASE_URL +  "api/Assets/report/" + institutionID + "/perinstitution";
      // window.open(uri, '_blank').focus();
  }


  return (
      <div id="content" className="content">
          <ol class="breadcrumb float-xl-right">
              <li class="breadcrumb-item">
                  {" "}
                  <Link to="/">Home </Link>{" "}
              </li>
              <li class="breadcrumb-item active">MOU Report</li>
          </ol>
          <h1 class="page-header mb-3">MOU Report</h1>
          <div style={{ backgroundColor: "white" }}>
      
              <hr />
              {state.length > 0 ? (
                  <div className="col-sm-12">
                      <div className="row">
                          <div className="col-sm-3">
                              {state.length > 0 ?
                                  <button
                                      onClick={handlePrint}
                                      className="btn btn-secondary p-2"
                                      style={{ marginRight: 5, marginTop: 5,display:"none" }}
                                  >
                                      &nbsp; Print \ Export &nbsp;
                                  </button> : null}
                          </div>
                      </div>
                      <div className="row">
                           
                          <div className="col-sm-12">
                              <h5 className="text-center">Ministry of Tourism and Wildlife</h5>
                              <h5 className="text-center">
                              National Tourism Service Portal
                              </h5>
                              <h5 className="text-center">MOU Report</h5>
                              <table class="table table-striped">
                                  <thead>
                                      <tr>
                                          <th scope="col">Id</th>
                                          <th scope="col">Signed Date </th>
                                          <th scope="col">Name</th>
                                          <th scope="col">Status</th>
                                          <th scope="col" >Country</th>
                                          <th scope="col">Date</th>
                                          <th scope="col">Actual Start Date</th>
                                          <th scope="col">Actual End Date</th>

                                      </tr>
                                  </thead>
                                  <tbody>
                                      {state.map((k) => {
                                          return (
                                              <tr>
                                                  <td>{k.id}</td>
                                                  <td>{k.signedDate}</td>
                                                  <td>{k.name}</td>
                                                  <td>{k.status}</td>
                                                  <td>{k.country}</td>
                                                  <td>{k.date}</td>
                                                  <td>{k.actualStartDate}</td>
                                                  <td>{k.actualEndDate}</td>
                                              </tr>
                                          );
                                      })}
                                  </tbody>
                                   <tfoot>
                                      <tr>
                                          <td colSpan="4">DATE:{Date.now()} </td>  
                                          {/* <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.innitialCost, 0))}</td>
                                          <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.presentBookValue, 0))}</td> */}
                                      </tr>
                                  </tfoot>
                              </table>
                          </div>
                          <div className="col-sm-2"></div>
                      </div>
                  </div>
              ) : null}
              <h3>{responsemessage}</h3> 
          </div>
      </div>
  );
};
export default MouReport;
